export const numberOfAccessPoints = 'numberOfAccessPoints';
export const selectTheDevice = 'selectTheDevice';
export const optionBusinessWifi = 'Business Wifi';

// Business Wi-Fi is $20/month only when it is the sole product on the order.
// Bundled with any other product the rate is $30/month, applied to both the
// product price and each access point beyond the first.
export const BUNDLED_MONTHLY_RATE = 30;

export const pricingFields = [numberOfAccessPoints];
